// extracted by mini-css-extract-plugin
export var root = "SupplyBlock-module--root--bzV3p";
export var title = "SupplyBlock-module--title--3NMCB";
export var subtitle = "SupplyBlock-module--subtitle--TgVyt";
export var content = "SupplyBlock-module--content--3Hoxu";
export var hasButtonBelow = "SupplyBlock-module--has-button-below--jPVy5";